import { SLUG_TEATRO_POR_HASH } from '@/constants/teatros';

/**
 * Slug del teatro dentro de las claves de traducción propias.
 *
 * @param {string} hash hash del teatro (`teatro.hash`)
 * @returns {string|null} slug del teatro, o null si no tiene textos propios
 */
export function slugTeatro(hash) {
    return SLUG_TEATRO_POR_HASH[hash] || null;
}

/**
 * Clave de traducción propia del teatro a partir de la clave genérica.
 *
 * @param {string} clave clave genérica (`renovar_abono.renovar`)
 * @param {string} hash hash del teatro (`teatro.hash`)
 * @returns {string} `clave_slug` si el teatro tiene textos propios, `clave` si no
 */
export function claveTeatro(clave, hash) {
    const slug = slugTeatro(hash);

    return slug ? `${clave}_${slug}` : clave;
}

/**
 * Resolvedor de textos que antepone la variante del teatro a la clave
 * genérica: usa `clave_<slug>` cuando existe y cae a `clave` cuando no.
 *
 * Así un club puede cambiar un texto sin clonar el componente y sin
 * afectar al resto de teatros, que siguen viendo el texto genérico.
 *
 * @param {object} i18n instancia de vue-i18n (`this.$i18n`)
 * @param {string} hash hash del teatro (`teatro.hash`)
 * @returns {{t: function(string, object=): string}} resolvedor de textos
 */
export function useTextosTeatro(i18n, hash) {
    function t(clave, params) {
        const clavePropia = claveTeatro(clave, hash);

        return i18n.te(clavePropia) ? i18n.t(clavePropia, params) : i18n.t(clave, params);
    }

    return { t };
}
